import axios from "axios"

axios.defaults.baseURL = process.env.REACT_APP_API_ENDPOINT

axios.defaults.xsrfHeaderName = "X-CSRFToken"
axios.defaults.xsrfCookieName = "csrftoken"

axios.defaults.withCredentials = true
